module.exports = __webpack_public_path__ + "static/media/charger.b0f5a8ce.png";